import styles from './Performance.module.scss'

interface Card {
  src: string
  alt: string
  title: string
  corporateName: string
  tags: string[]
  button?: boolean
  href?: string
}

const cards: Card[] = [
  {
    src: '/images/img/case/img_case_mss.png',
    alt: 'マンション一斉入居サービス MSS',
    title: 'マンション一斉入居サービス MSS',
    corporateName: 'アート引越センター株式会社',
    tags: ['AWS Fargate', 'Amazon RDS', 'Laravel'],
    button: true,
    href: '/cases/mss',
  },
  {
    src: '/images/img/case/img_case_dsa.png',
    alt: 'アシスタントロボ',
    title: 'アシスタントロボ',
    corporateName: 'データスタジアム株式会社',
    tags: ['Laravel', 'Amazon ECS', 'AWS Fargate', 'Amazon RDS'],
    button: true,
    href: '/cases/assistantrobo',
  },
  {
    src: '/images/img/case/img_case_doic.png',
    alt: 'docomo Open Inovation Cloud',
    title: 'docomo Open Inovation Cloud',
    corporateName: '株式会社NTTドコモ',
    tags: ['AWS Lambda', 'Amazon ECS', 'AWS Fargate', 'Amazon RDS'],
  },
]

const Performance: React.FC = () => {
  const card = cards.map(({ src, alt, title, corporateName, tags, button, href }) => (
    <li key={src} className={styles.li}>
      <img src={src} alt={alt} className={styles.img} />
      <div className={styles.text_wrapper}>
        <span className={styles.card_title}>{title}</span>
        <span className={styles.corporate_name}>{corporateName}</span>
        <div className={styles.tag_wrapper}>
          {tags.map((tag) => (
            <span key={`${src} - ${tag}`} className={styles.tag}>
              #{tag}
            </span>
          ))}
        </div>
        {button && (
          <a className={styles.button} href={href} target="_blank" rel="noopener">
            詳細を見る
          </a>
        )}
      </div>
    </li>
  ))

  return (
    <section className={styles.section} id="performance">
      <div className={styles.wrapper}>
        <h2 className={styles.title}>実績</h2>
        <span className={styles.minitext}>実績の一部をご紹介します。</span>
        <div className={styles.card_wrapper}>
          <ul className={styles.ul}>{card}</ul>
        </div>
      </div>
    </section>
  )
}

export default Performance
